import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import { IndicatorProd } from './Indicator';

export const Indicators = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div className="d-flex flex-column flex-grow-1" style={{ gap: '10px' }}>
            <IndicatorProd />
            <Card
                title="Quantidade Aprovada"
                value={number.formatToBRNumber(
                    chartData?.indexes[0]?.quantidade_aprovada || 0
                )}
            />
            <Card
                title="Quantidade Produzida"
                value={number.formatToBRNumber(
                    chartData?.indexes[0]?.quantidade_produzida || 0
                )}
            />
        </div>
    );
};
